import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './buttons.scss';
import questionDisplayStyles from '../question/QuestionDisplay.scss';
import constants from '../../qti/Constants';
import feedbackService from '../../services/FeedbackService';

const FeedbackNavigationButton = ({
    buttonType,
    label,
    destinationSelector,
}) => {
    const [canNavigate, setCanNavigate] = useState(true);

    const navigationHandler = () => {
        setCanNavigate(false);
        const feedbackElement = feedbackService.resolveFeedbackElement(destinationSelector);

        feedbackElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        feedbackElement.classList.add(questionDisplayStyles.highlightInteractionWrapper);
        setTimeout(() => {
            feedbackElement.classList.remove(questionDisplayStyles.highlightInteractionWrapper);
            setCanNavigate(true);
        }, constants.animationDuration);

        return true;
    };

    return (
        <button
            className={`${styles.button} ${styles.feedbackNavigationButton} ${buttonType !== 'questionEntry' ? styles.removeMargin : ''}`}
            rel="noreferrer noopener"
            onClick={canNavigate ? navigationHandler : null}
        >
            {label}
        </button>
    );
};

FeedbackNavigationButton.propTypes = {
    label: PropTypes.string.isRequired,
    destinationSelector: PropTypes.string.isRequired,
    buttonType: PropTypes.oneOf(['questionEntry', 'responseOutcome']).isRequired,
};

export default FeedbackNavigationButton;
